import React from 'react';
import { AuthorName, AuthorsNameList, AuthorImage, AuthorsImageList, formatter } from './utils';
import TimeAgo from 'react-timeago';

export function MultipleAuthorTemplate({ authors = [], showDateOnly = false, config = {}, hideImage = false, isLink, authorNameKeyword, storyPubKeyword, date}) {
  const authorsLength = authors.length;
  const publishKeyword = !showDateOnly && get(config, ['theme-attributes', 'lang'] !== 'ar') ? 'Published on : ' : '';

  return <div className="author author--multiple">
    <div className="author__avatars">
      { !hideImage && <AuthorsImageList authors={authors} isLink={isLink} /> }
    </div>
    <div className="author__content">
      { authorNameKeyword }
      <AuthorsNameList authors={authors} authorsLength={authorsLength} isLink={isLink} />
      { date && <p className="author__published-date">
        { storyPubKeyword || (publishKeyword && <span className="pub-keyword">Published on : </span>) }
        <TimeAgo date={date} formatter={(value, unit, suffix, date, defaultFormatter) => formatter(value, unit, suffix, date, defaultFormatter, config)}/>
      </p>}
    </div>
  </div>
}